/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Referral_Reactivate_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not reactivate referral code." |
*
* @param {Partner_Referral_Reactivate_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_referral_reactivate_error = /** @type {((inputs?: Partner_Referral_Reactivate_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Referral_Reactivate_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Empfehlungscode konnte nicht reaktiviert werden.")
	return /** @type {LocalizedString} */ ("Could not reactivate referral code.")
});